(function (window) {
  'use strict';

  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  function repriseStatusSlug(r) {
    if (!r) return '';
    if (typeof r.status_slug === 'string' && r.status_slug) return r.status_slug;
    if (r.status && typeof r.status === 'object' && r.status.slug) return r.status.slug;
    if (typeof r.status === 'string') return r.status;
    return '';
  }

  function computeReprisesState(r) {
    var helpers = window.buybackPortalHelpers;
    var slug = repriseStatusSlug(r);
    if (helpers && typeof helpers.computeStateFromTimeline === 'function') {
      return helpers.computeStateFromTimeline(r, slug, r && r.substep);
    }
    if (helpers && typeof helpers.computeStateFromSlug === 'function') {
      return helpers.computeStateFromSlug(slug, r && r.substep);
    }
    return 'pending';
  }

  function statusModifierFromState(state) {
    if (state === 'emitted') return 'mint';
    if (state === 'paid' || state === 'transport') return 'yellow-fluo';
    if (state === 'contractualisation' || state === 'received') return 'yellow-lime';
    if (state === 'refused') return 'coral';
    if (state === 'pending') return 'mint-pale';
    return 'grey';
  }

  function statusLabelFromState(state, reprise) {
    var i18n = window.buybackPortalI18n || {};
    var helpers = window.buybackPortalHelpers;
    if (state === 'refused') {
      var slug = repriseStatusSlug(reprise);
      if (slug === 'proposition_expiree') {
        return i18n.statuses_expired || t('statuses_expired') || 'Offre expirée';
      }
      // Aligne le label liste sur celui du composant progress (helpers.renderProgress).
      // Wording volontairement inversé vs la sémantique du slug :
      //   slug proposition_refusee → "Demande refusée"
      //   slug demande_refusee     → "Proposition refusée"
      var refusedKey =
        slug === 'proposition_refusee' ? 'progress_refused_proposition_label' : 'progress_refused_demande_label';
      return i18n[refusedKey] || t(refusedKey) || i18n.statuses_refused || 'Reprise refusée';
    }
    // Source unique de vérité partagée avec le composant progress du détail.
    if (helpers && typeof helpers.resolveCurrentStepLabel === 'function') {
      return helpers.resolveCurrentStepLabel(reprise);
    }
    // Fallback dégradé (helpers non chargés) : utilise normalizeStepLabel si dispo.
    var steps = (reprise && reprise.timeline && reprise.timeline.steps) || [];
    var current = null;
    for (var i = 0; i < steps.length; i++) {
      if (steps[i] && steps[i].current) {
        current = steps[i];
        break;
      }
    }
    var raw = (current && current.label) || '';
    var slug2 = (current && (current.slug || current.key || current.id)) || repriseStatusSlug(reprise);
    if (/^[A-Z_]+$/.test(raw)) raw = raw.toLowerCase();
    if (helpers && typeof helpers.normalizeStepLabel === 'function') {
      return helpers.normalizeStepLabel(raw, slug2) || i18n.statuses_unknown || 'Statut inconnu';
    }
    return raw || i18n.statuses_unknown || 'Statut inconnu';
  }

  function formatPrice(p) {
    if (p === null || p === undefined || p === '') return '';
    return p + ' €';
  }

  function dateLocale() {
    var lc = (window.buybackPortal && window.buybackPortal.locale) || 'fr';
    return lc === 'en' ? 'en-GB' : 'fr-FR';
  }

  function formatFullDate(d) {
    if (!d) return '';
    var date = new Date(d);
    if (isNaN(date.getTime())) return '';
    try {
      return date.toLocaleDateString(dateLocale(), { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return '';
    }
  }

  function computeSubstepFor(reprise, state, listInstance) {
    if (state !== 'contractualisation') return 'none';
    // Source prioritaire : `reprise.substep` si fourni par le backend (payload
    // list optimisé). Évite le bug où ContractualisationSubstep retourne 'none'
    // pour NON-PART parce que `pickup_requested_date` n'est pas sérialisé en
    // liste (cf. list-actions.js:207 qui doit re-fetch le detail pour l'obtenir).
    if (reprise && typeof reprise.substep === 'string' && reprise.substep) {
      return reprise.substep;
    }
    var Substep = window.ContractualisationSubstep;
    if (typeof Substep !== 'function') return 'none';
    try {
      // Fix bug latent : `reprise.vendorType` camelCase n'existe pas dans le
      // payload RepriseListItem (champ snake `vendor_type` non sérialisé en
      // liste). Source canonique = helpers.normalizeVendorType qui croise
      // reprise.vendor_type et me.vendorType.
      var helpers = window.buybackPortalHelpers;
      var me =
        (listInstance && listInstance._cachedMe) ||
        (window.buybackPortalContext && window.buybackPortalContext.me) ||
        null;
      var vendorType =
        helpers && typeof helpers.normalizeVendorType === 'function'
          ? helpers.normalizeVendorType(reprise, me)
          : (reprise && reprise.vendor_type) || 'PART';
      var computed = new Substep(reprise, vendorType).compute() || 'none';
      if (computed !== 'none') return computed;
      // Fallback timeline : si on est en contractualisation ET au moins UN doc
      // est attendu/uploadé (docs map non vide), c'est que la boutique/date a
      // déjà été choisie. Évite de proposer "Choisir la date" alors qu'on est
      // déjà à l'étape upload docs.
      var docs = (reprise && reprise.docs) || null;
      if (docs && typeof docs === 'object') {
        var docKeys = Object.keys(docs);
        for (var i = 0; i < docKeys.length; i++) {
          var d = docs[docKeys[i]];
          if (d && (d.status === 'received' || d.status === 'pending' || d.id)) {
            // au moins un doc reçu → docs_uploaded ; sinon → store_chosen
            return d.status === 'received' ? 'docs_uploaded' : 'store_chosen';
          }
        }
      }
      return 'none';
    } catch (e) {
      return 'none';
    }
  }

  function makeCtaButton(className, label, action) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    btn.textContent = label;
    if (action) btn.setAttribute('data-action', action);
    return btn;
  }

  function buildCtas(reprise, state, listInstance) {
    var ctaWrap = document.createElement('div');
    ctaWrap.className = 'buyback-portal__card-cta';

    var substep = computeSubstepFor(reprise, state, listInstance);
    var primaryLabel = null;
    var primaryAction = null;
    var showRefuse = false;

    if (state === 'emitted') {
      primaryLabel = t('cta_accepter') || 'Accepter';
      primaryAction = 'accept';
      showRefuse = true;
    } else if (state === 'contractualisation') {
      if (substep === 'docs_uploaded') {
        primaryLabel = (t('cta_signer_contrat') || 'Signer le contrat') + ' →';
        primaryAction = 'sign-contract';
      } else if (substep === 'store_chosen') {
        primaryLabel = (t('cta_ajouter_documents') || 'Ajouter mes documents') + ' →';
        primaryAction = 'upload-docs';
      } else {
        // Substep == 'none' : différencie PART (pick-store) vs non-PART (pick-pickup-date).
        // Source canonique du vendor_type = helpers.normalizeVendorType (croise
        // reprise.vendor_type et me.vendorType). Fallback PART si helpers indispo.
        var helpers = window.buybackPortalHelpers;
        var me =
          (listInstance && listInstance._cachedMe) ||
          (window.buybackPortalContext && window.buybackPortalContext.me) ||
          null;
        var partFlag = helpers && typeof helpers.isPart === 'function' ? helpers.isPart(reprise, me) : true;
        if (partFlag) {
          primaryLabel = (t('cta_choisir_boutique') || 'Choisir la boutique') + ' →';
          primaryAction = 'pick-store';
        } else {
          primaryLabel = (t('cta_programmer_enlevement') || 'Choisir la date d’enlèvement') + ' →';
          primaryAction = 'pick-pickup-date';
        }
      }
    }

    if (primaryLabel) {
      var primary = makeCtaButton('buyback-portal__card-cta-primary', primaryLabel, primaryAction);
      ctaWrap.appendChild(primary);
      if (showRefuse) {
        ctaWrap.classList.add('buyback-portal__card-cta--row');
        var refuse = makeCtaButton('buyback-portal__card-cta-link', t('cta_refuser') || 'Refuser', 'refuse');
        ctaWrap.appendChild(refuse);
      }
    } else {
      var outline = makeCtaButton(
        'buyback-portal__card-cta-outline',
        (t('cta_voir_detail') || 'Voir le détail') + ' →',
        'view-detail',
      );
      ctaWrap.appendChild(outline);
    }

    ctaWrap.addEventListener('click', function (e) {
      var target = e.target.closest && e.target.closest('[data-action]');
      if (!target) return;
      e.preventDefault();
      e.stopPropagation();
      var action = target.getAttribute('data-action');
      var actions = window.buybackPortalListActions;
      if (actions && typeof actions.handleAction === 'function') {
        actions.handleAction(action, reprise.id, listInstance);
      } else if (reprise.id) {
        window.location.hash = '#/detail/' + encodeURIComponent(reprise.id);
      }
    });

    return ctaWrap;
  }

  class BuybackPortalList extends HTMLElement {
    connectedCallback() {
      this._onLogout = this._handleLogout.bind(this);
      var logoutBtn = this.querySelector('[data-bp-logout]');
      if (logoutBtn) logoutBtn.addEventListener('click', this._onLogout);
      this._loadData();
    }

    disconnectedCallback() {
      var logoutBtn = this.querySelector('[data-bp-logout]');
      if (logoutBtn && this._onLogout) logoutBtn.removeEventListener('click', this._onLogout);
    }

    async _loadData() {
      try {
        var meRes = await window.buybackApi.me();
        // Cache me + vendorType pour buildCtas/computeSubstepFor.
        // `meRes` retourné par /me est déjà l'objet user (firstName, vendorType, etc.).
        this._cachedMe = meRes || null;
        var vt = (meRes && meRes.vendorType) || (meRes && meRes.user && meRes.user.vendorType) || null;
        window.buybackPortalContext = { me: meRes || null, vendorType: vt };
        var listRes = await window.buybackApi.listReprises();
        var reprises = (listRes && listRes.reprises) || [];
        this._renderGreeting(meRes);
        var lastUpdate = null;
        reprises.forEach(function (r) {
          var d = r.updatedAt || r.depositedAt;
          if (d) {
            var ts = new Date(d).getTime();
            if (!lastUpdate || ts > lastUpdate) lastUpdate = ts;
          }
        });
        this._renderMeta(reprises.length, lastUpdate);
        this._renderCards(reprises);
      } catch (err) {
        if (err.message === 'UNAUTHENTICATED') return;
        this._renderError();
      }
    }

    _renderGreeting(me) {
      var el = this.querySelector('[data-bp-greeting]');
      if (el && me && me.firstName) {
        el.textContent = (t('greeting_prefix') || 'Bonjour, ') + me.firstName;
      }
    }

    _renderMeta(count, lastUpdate) {
      var el = this.querySelector('[data-bp-meta]');
      if (!el) return;
      var template =
        count <= 1
          ? t('list_meta_singular') || '{{ count }} demande · Dernière mise à jour {{ last_update }}'
          : t('list_meta_plural') || '{{ count }} demandes · Dernière mise à jour {{ last_update }}';
      var lu = lastUpdate ? new Date(lastUpdate).toLocaleDateString(undefined) : '—';
      el.textContent = template.replace('{{ count }}', String(count)).replace('{{ last_update }}', lu);
    }

    _renderCards(reprises) {
      var ul = this.querySelector('[data-bp-cards]');
      if (!ul) return;
      ul.textContent = '';
      var self = this;
      reprises.forEach(function (r) {
        ul.appendChild(self._buildCard(r));
      });
    }

    _buildCard(r) {
      var li = document.createElement('li');
      li.className = 'buyback-portal__card';

      var hasId = !!r.id;
      var detailHref = hasId ? '#/detail/' + encodeURIComponent(r.id) : null;

      if (detailHref) {
        var overlay = document.createElement('a');
        overlay.className = 'buyback-portal__card-link-overlay';
        overlay.href = detailHref;
        var titleLabel = ((r.brand || '') + ' ' + (r.model || '')).trim();
        overlay.setAttribute('aria-label', (t('cta_voir_detail') || 'Voir le détail') + ' ' + titleLabel);
        overlay.textContent = titleLabel || t('cta_voir_detail') || 'Voir le détail';
        li.appendChild(overlay);
      }

      var photo = document.createElement('div');
      photo.className = 'buyback-portal__card-photo';
      if (r.thumbnailUrl) {
        var img = document.createElement('img');
        img.src = r.thumbnailUrl;
        img.alt = (r.brand || '') + ' ' + (r.model || '');
        img.loading = 'lazy';
        photo.appendChild(img);
      }
      li.appendChild(photo);

      var body = document.createElement('div');
      body.className = 'buyback-portal__card-body';

      var ref = document.createElement('span');
      ref.className = 'buyback-portal__card-ref';
      var refPrefix = t('card_ref_prefix') || 'DEMANDE ';
      // Ne montre pas l'UUID brut quand code_mint manque (cf bug post-mutation
      // où result.reprise partielle écrase code_mint).
      var refLabel = r.code_mint || r.reference || '';
      ref.textContent = refLabel ? refPrefix + '#' + refLabel : refPrefix.trim();
      body.appendChild(ref);

      var title = document.createElement('h3');
      title.className = 'buyback-portal__card-title';
      title.textContent = (r.brand || '') + ' ' + (r.model || '');
      body.appendChild(title);

      var meta = document.createElement('p');
      meta.className = 'buyback-portal__card-meta';
      var metaParts = [];
      var depositedStr = formatFullDate(r.depositedAt);
      if (depositedStr) metaParts.push((t('card_deposited_prefix') || 'Déposée le ') + depositedStr);
      if (r.size) metaParts.push((t('card_size_prefix') || 'Taille ') + r.size);
      if (r.type) metaParts.push(r.type);
      if (r.year) metaParts.push(String(r.year));
      meta.textContent = metaParts.join(' · ');
      body.appendChild(meta);

      li.appendChild(body);

      var state = computeReprisesState(r);

      var right = document.createElement('div');
      right.className = 'buyback-portal__card-right';

      var statusWrap = document.createElement('div');
      statusWrap.className = 'buyback-portal__card-status';
      var status = document.createElement('span');
      status.className = 'buyback-portal__status buyback-portal__status--' + statusModifierFromState(state);
      status.textContent = statusLabelFromState(state, r);
      statusWrap.appendChild(status);
      right.appendChild(statusWrap);

      if (r.price) {
        var priceWrap = document.createElement('div');
        priceWrap.className = 'buyback-portal__card-price';
        var price = document.createElement('h3');
        price.className = 'buyback-portal__card-price-value';
        price.textContent = formatPrice(r.price);
        priceWrap.appendChild(price);
        right.appendChild(priceWrap);
      }

      var ctaWrap = buildCtas(r, state, this);
      right.appendChild(ctaWrap);

      li.appendChild(right);

      return li;
    }

    async _handleLogout(e) {
      e.preventDefault();
      try {
        await window.buybackApi.logout();
      } finally {
        if (history && history.replaceState) {
          history.replaceState(null, '', '#/login');
        } else {
          window.location.hash = '#/login';
        }
        window.location.reload();
      }
    }

    _renderError() {
      var ul = this.querySelector('[data-bp-cards]');
      if (!ul) return;
      ul.textContent = '';
      var li = document.createElement('li');
      var p = document.createElement('p');
      p.className = 'buyback-portal__error';
      p.setAttribute('role', 'alert');
      p.textContent = t('error_generic') || 'Erreur, réessayez plus tard.';
      li.appendChild(p);
      ul.appendChild(li);
    }
  }

  if (!customElements.get('buyback-portal-list')) {
    customElements.define('buyback-portal-list', BuybackPortalList);
  }
})(window);
